import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 화면 이동 시 스크롤을 맨 위로. 메뉴를 눌렀는데 이전 화면의 스크롤 위치가 남아
 * 사용자가 직접 위로 올려야 하는 문제를 막는다.
 * 단, 해시 링크(/glossary#suit)는 해당 위치로 가야 하므로 건드리지 않는다.
 */
export function ScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // 해시 대상이 렌더된 뒤에 이동
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // ⚠️ scrollIntoView()의 반환값을 return 하면 React가 cleanup 함수로 오인해
        //    다음 렌더에서 호출하려다 죽는다("destroy is not a function" → 화면 백지).
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

/** 이 높이 이상 내려가면 위로 가기 버튼을 띄운다 */
const SHOW_AFTER_PX = 400;

/**
 * 맨 위로 가기 버튼 — 본문 열(column) 오른쪽 아래에 붙는다.
 * 화면 우측 끝이 아니라 본문 폭에 맞춰 두어야 PC에서 동떨어져 보이지 않는다.
 */
export function ScrollToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      aria-hidden={!show}
      className={`pointer-events-none fixed inset-x-0 bottom-0 z-40 transition-opacity duration-200 ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* fixed라 AppShell의 safe-area 패딩이 안 먹는다 — 홈 인디케이터 위로 직접 띄운다 */}
      <div className="mx-auto flex w-full max-w-md justify-end px-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))]">
        <button
          type="button"
          tabIndex={show ? 0 : -1}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="맨 위로"
          // 본문을 가리지 않도록 반투명 — 올려두면 또렷해진다
          className="pointer-events-auto flex h-11 w-11 items-center justify-center rounded-full border border-gold/25 bg-night-2/40 text-gold/60 opacity-50 backdrop-blur-sm transition hover:border-gold/60 hover:bg-night-2/80 hover:text-gold hover:opacity-100 active:opacity-100"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
            aria-hidden
          >
            <path d="M12 19V6" />
            <path d="M6 11.5 12 5.5l6 6" />
          </svg>
        </button>
      </div>
    </div>
  );
}
